import React, { useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import { getCurrentUserRole } from '../utils/authHelper';
import '../styles/LoginPage.css';

export default function ChangePassword() {
    const [newPassword, setNewPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirm) {
            setError('Die Passwörter stimmen nicht überein.');
            return;
        }
        if (newPassword.length < 8) {
            setError('Das Passwort muss mindestens 8 Zeichen lang sein.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/change-password', { new_password: newPassword });
            const role = getCurrentUserRole();
            if (role === 'super_admin') navigate('/admin', { replace: true });
            else if (role === 'admin') navigate('/employee-hours', { replace: true });
            else navigate('/timetracking', { replace: true });
        } catch (err) {
            setError('Passwort konnte nicht gesetzt werden. Bitte versuchen Sie es erneut.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <h2 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' }}>Passwort festlegen</h2>
            <p style={{ margin: '0 0 24px', color: 'var(--color-text-secondary)', fontSize: 14 }}>
                Bitte legen Sie ein neues Passwort fest, bevor Sie fortfahren.
            </p>
            <form onSubmit={handleSubmit} className="login-form">
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: 'var(--color-text)' }}>
                    Neues Passwort
                </label>
                <input
                    data-testid="change-password-new"
                    type="password"
                    placeholder="Mindestens 8 Zeichen"
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    className="login-input"
                    required
                />
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, marginTop: 12, color: 'var(--color-text)' }}>
                    Passwort bestätigen
                </label>
                <input
                    data-testid="change-password-confirm"
                    type="password"
                    placeholder="Passwort wiederholen"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                    className="login-input"
                    required
                />
                <button
                    data-testid="change-password-submit"
                    className="button"
                    type="submit"
                    disabled={loading}
                    style={{ background: 'var(--color-primary)', color: '#fff', padding: '10px', fontWeight: 600, fontSize: 15, borderRadius: 8, marginTop: 8 }}
                >
                    {loading ? 'Wird gespeichert…' : 'Passwort speichern'}
                </button>
                {error && <p data-testid="change-password-error" className="login-error">{error}</p>}
            </form>
        </div>
    );
}
